import { useEffect, useState } from 'react';
import './Slider.css';

const slides = [
  {
    image: '/images/sliderimages/Artboard-1.jpg',
    mobileImage: '/images/sliderimages/Artboard-1-1.jpg',
    title: 'Advanced Fertility Care',
    subtitle: 'Personalized treatment plans with compassion and expertise.',
  },
  {
    image: '/images/sliderimages/Artboard-2.jpg',
    mobileImage: '/images/sliderimages/Artboard-2-1.jpg',
    title: 'A Hopeful Future',
    subtitle: 'Modern labs, experienced specialists, and high success rates.',
  },
  {
    image: '/images/sliderimages/Artboard-3.jpg',
    mobileImage: '/images/sliderimages/Artboard-3-1.jpg',
    title: 'Your Journey Starts Here',
    subtitle: 'From consultation to care, we guide you every step of the way.',
  },
  {
    image: '/images/sliderimages/Artboard-4.jpg',
    mobileImage: '/images/sliderimages/Artboard-4-1.jpg', 
    title: 'Trusted IVF Solutions',
    subtitle: 'Helping families create lasting memories with confidence.',
  },
];

function Slider() {
  const [activeIndex, setActiveIndex] = useState(0);

  useEffect(() => {
    const timer = window.setInterval(() => {
      setActiveIndex((prev) => (prev + 1) % slides.length);
    }, 5000);

    return () => window.clearInterval(timer);
  }, []);

  const goToSlide = (index) => setActiveIndex(index);
  const showPrev = () => setActiveIndex((prev) => (prev - 1 + slides.length) % slides.length);
  const showNext = () => setActiveIndex((prev) => (prev + 1) % slides.length);

  return (
    <section className="slider" aria-label="Featured slides">
      <div className="slider-track">
        {slides.map((slide, index) => (
          <div key={slide.image} className={`slide ${index === activeIndex ? 'active' : ''}`}>
            <picture>
              <source media="(max-width: 768px)" srcSet={slide.mobileImage} />
              <img src={slide.image} alt={slide.title} />
            </picture>
            <div className="slide-overlay">
              <h2>{slide.title}</h2>
              <p>{slide.subtitle}</p>
            </div>
          </div>
        ))}
      </div>

      <button type="button" className="slider-control prev" onClick={showPrev} aria-label="Previous slide">
        &#10094;
      </button>
      <button type="button" className="slider-control next" onClick={showNext} aria-label="Next slide">
        &#10095;
      </button>

      <div className="slider-dots" aria-label="Slide indicators">
        {slides.map((slide, index) => (
          <button
            key={slide.image}
            type="button"
            className={`dot ${index === activeIndex ? 'active' : ''}`}
            onClick={() => goToSlide(index)}
            aria-label={`Go to slide ${index + 1}`}
          />
        ))}
      </div>
    </section>
  );
}

export default Slider;
